import React, { useState, useEffect } from "react";
import AppShell from "../components/layout/AppShell";
import AppFooter from "../components/layout/AppFooter";
import TopNav from "../components/layout/TopNav";

const faqs = [
    {
        q: "En quoi consiste Solvya ?",
        a: "Solvya est une plateforme d'assistance informatique 100% à distance. Vous décrivez votre problème, un technicien qualifié et vérifié prend la main sur votre écran en quelques secondes pour le résoudre. Pas de déplacement, pas d'attente, paiement uniquement sur la durée réelle d'intervention."
    },
    {
        q: "Pourquoi faire confiance à Solvya ?",
        a: "Chaque technicien passe une analyse IA de son CV avant d'être accepté sur la plateforme. Ses compétences, son parcours et la cohérence de son profil sont vérifiés. Un scoring continu basé sur les avis clients assure un niveau de qualité permanent. De plus, chaque session est tracée et sécurisée — vous gardez le contrôle à tout moment et pouvez couper la connexion en un clic."
    },
    {
        q: "Comment se déroule une session à distance concrètement ?",
        a: "Vous créez un ticket en décrivant votre problème. Un technicien disponible le prend en charge. Vous cliquez sur \"Rejoindre la session\" — votre navigateur vous demande de partager votre écran. Le technicien voit votre écran en temps réel et peut vous guider ou intervenir directement. Vous pouvez communiquer via le chat intégré pendant toute la session. À la fin, vous évaluez la prestation."
    },
    {
        q: "Pourquoi c'est mieux que de déposer son PC en magasin ?",
        a: "Plusieurs raisons : pas de déplacement, pas d'attente de plusieurs jours, tarification transparente à la minute (vous savez exactement ce que vous payez), disponibilité 24h/24 et 7j/7, et un diagnostic IA dès la soumission du ticket. Pour la majorité des problèmes logiciels, réseau ou configuration, une intervention à distance est aussi efficace qu'une intervention physique — et bien plus rapide."
    },
    {
        q: "Combien ça coûte exactement ?",
        a: "20€ au démarrage de la session, puis 0,75€ par minute d'intervention. Vous payez uniquement le temps réel passé par le technicien sur votre problème. Aucun abonnement obligatoire, aucun frais caché. La facturation est automatique à la fin de chaque session."
    },
    {
        q: "Pourquoi dois-je avoir un moyen de paiement actif pour créer une demande ?",
        a: "Un moyen de paiement enregistré garantit que la facturation peut se faire automatiquement à la fin de la session, sans interruption du service. Sans cela, un technicien pourrait intervenir sans pouvoir être rémunéré. Vos données bancaires ne sont jamais stockées sur nos serveurs — elles sont gérées exclusivement par Stripe, acteur de référence mondial du paiement en ligne."
    },
    {
        q: "Mes données sont-elles en sécurité pendant la session ?",
        a: "Oui. La connexion est chiffrée de bout en bout via WebRTC. Le technicien voit uniquement ce que vous choisissez de partager (un écran, une fenêtre). Vous pouvez couper le partage à tout moment. Toutes les sessions sont tracées et horodatées. En cas de comportement suspect, notre système de signalement permet d'alerter immédiatement l'équipe Solvya."
    },
    {
        q: "Les techniciens sont-ils des professionnels vérifiés ?",
        a: "Oui. Tous les techniciens devront fournir des justificatifs de qualification et d'identité (KYC). Chaque technicien soumet son CV qui est analysé par Solvya : compétences détectées, niveau de support évalué, incohérences signalées. Un score est calculé et seuls les profils au-dessus d'un seuil minimum sont acceptés. Après chaque intervention, les clients laissent un avis qui impacte directement le score du technicien. Les profils insuffisants sont désactivés."
    },
    {
        q: "Que faire en cas de litige ou de technicien incompétent ?",
        a: "À la fin de chaque session, vous pouvez laisser un avis et activer le signalement si la prestation ne vous a pas satisfait. Dans ce cas, le paiement est suspendu et le ticket passe en statut \"Vérification en cours\". Notre équipe examine le dossier manuellement avant de valider ou annuler le paiement. En cas de problème urgent, contactez-nous directement à l'adresse ci-dessous."
    },
    {
        q: "Est-ce que je peux annuler une session en cours ?",
        a: "Oui, vous pouvez quitter une session à tout moment. Seul le temps effectivement passé par le technicien sur votre problème vous est facturé. Si vous quittez dans les premières secondes avant toute intervention réelle, contactez notre support pour un examen du dossier."
    },
];

export default function Contact({ onNavigate, isLoggedIn, onLogout, openFaq }) {
    const [open, setOpen] = useState(openFaq !== undefined ? openFaq : null);

    useEffect(() => {
        if (openFaq !== undefined) {
            // Scroll vers la FAQ après le render
            setTimeout(() => {
                const el = document.getElementById(`faq-${openFaq}`);
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
        }
    }, [openFaq]);

    return (
        <AppShell
            header={<TopNav isLoggedIn={isLoggedIn} onLogout={onLogout} onNavigate={onNavigate} />}
            footer={<AppFooter onNavigate={onNavigate} />}
            onNavigate={onNavigate}
        >
            <div style={{ maxWidth: 780, margin: "0 auto", padding: "40px 24px 80px" }}>
                <button
                    onClick={() => onNavigate("home")}
                    style={{
                        background: "none", border: "none", color: "rgba(180,180,200,0.75)",
                        fontSize: 13, cursor: "pointer", padding: 0, marginBottom: 28,
                        display: "flex", alignItems: "center", gap: 6,
                    }}
                >
                    ← Retour
                </button>

                {/* Header */}
                <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: "-0.025em", marginBottom: 8 }}>
                    Aide & Contact
                </h1>
                <p style={{ color: "rgba(180,180,200,0.70)", fontSize: 14, marginBottom: 56, lineHeight: 1.6 }}>
                    Retrouvez les réponses aux questions les plus fréquentes. Si vous ne trouvez pas ce que vous cherchez, contactez-nous directement.
                </p>

                {/* FAQ */}
                <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, letterSpacing: "-0.01em" }}>
                    Questions fréquentes
                </h2>

                <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 64 }}>
                    {faqs.map((faq, i) => (
                        <div
                            key={i}
                            id={`faq-${i}`}
                            style={{
                                background: open === i ? "rgba(110,86,207,0.08)" : "rgba(255,255,255,0.03)",
                                border: `1px solid ${open === i ? "rgba(110,86,207,0.30)" : "rgba(255,255,255,0.07)"}`,
                                borderRadius: 14,
                                overflow: "hidden",
                                transition: "all 180ms ease",
                            }}
                        >
                            <button
                                onClick={() => setOpen(open === i ? null : i)}
                                style={{
                                    width: "100%", textAlign: "left", padding: "18px 20px",
                                    background: "none", border: "none", cursor: "pointer",
                                    display: "flex", justifyContent: "space-between", alignItems: "center",
                                    gap: 16,
                                }}
                            >
                                <span style={{ fontSize: 14, fontWeight: 600, color: "rgba(230,230,245,0.95)", lineHeight: 1.4 }}>
                                    {faq.q}
                                </span>
                                <span style={{
                                    fontSize: 16, color: "#6E56CF", flexShrink: 0,
                                    transform: open === i ? "rotate(45deg)" : "rotate(0deg)",
                                    transition: "transform 180ms ease",
                                }}>
                                    +
                                </span>
                            </button>

                            {open === i && (
                                <div style={{ padding: "0 20px 20px" }}>
                                    <p style={{
                                        fontSize: 14, color: "rgba(190,190,210,0.85)",
                                        lineHeight: 1.7, margin: 0,
                                    }}>
                                        {faq.a}
                                    </p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Contact */}
                <div style={{
                    padding: "36px 32px",
                    background: "rgba(110,86,207,0.08)", border: "1px solid rgba(110,86,207,0.22)",
                    borderRadius: 18, textAlign: "center",
                }}>
                    <div style={{ fontSize: 28, marginBottom: 14 }}>✉️</div>
                    <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 10px", letterSpacing: "-0.02em" }}>
                        Vous n'avez pas trouvé votre réponse ?
                    </h2>
                    <p style={{ fontSize: 14, color: "rgba(180,180,200,0.80)", margin: "0 0 24px", lineHeight: 1.6 }}>
                        Notre équipe répond dans les plus brefs délais, généralement sous 24h.
                    </p>
                    <a
                        href="mailto:contact@solvya.io"
                        style={{
                            display: "inline-flex", alignItems: "center", gap: 8,
                            padding: "12px 24px", borderRadius: 12,
                            background: "linear-gradient(180deg,rgba(110,86,207,0.38),rgba(110,86,207,0.26))",
                            border: "1px solid rgba(110,86,207,0.65)", color: "#fff",
                            fontSize: 14, fontWeight: 600, textDecoration: "none",
                            boxShadow: "0 8px 22px rgba(110,86,207,0.22)",
                        }}
                    >
                        Contacter le support →
                    </a>
                    <p style={{ fontSize: 12, color: "rgba(150,150,170,0.60)", marginTop: 16 }}>
                        contact@solvya.io
                    </p>
                </div>
            </div>
        </AppShell>
    );
}